import r, { OPTIONS as z } from "../managers/braze-instance.js";
import na from "./push-manager.js";
const ra = {
  l: !1,
  aa: null,
  ea: () => (
    ra.p(),
    ra.aa ||
      (ra.aa = new na(
        r.gr(),
        r.ba(),
        r.ue(),
        r.Z(),
        r.ee(z.Ma),
        r.ee(z._a),
        r.ee(z.ka),
        r.v(),
        r.ee(z.qa),
        r.ee(z.Aa),
        r.j(),
      )),
    ra.aa
  ),
  p: () => {
    ra.l || (r.h(ra), (ra.l = !0));
  },
  destroy: () => {
    (ra.aa = null), (ra.l = !1);
  },
};
export default ra;
